import service from '../service/buyer'
import CONSTANT from '../constant/buyer'
import _ from 'underscore'
import op from "object-path";

export default {
    getItemBuyer({ state, commit }, id) {
        return new Promise((resolve, reject) => {
            const list = state.buyerShowBrief
            const brief = _.find(list, (v) => {
                return v.id == id
            })
            if (brief && (!_.isEmpty(brief.data))) {
                return resolve(brief.data)
            }
            return service.getItemBuyer(id).then(result => {
                if (_.isEmpty(result) || _.isEmpty(result.buyer) || _.isEmpty(result.buyerShow)) {
                    reject([])
                    commit(CONSTANT.BUYER_SHOW_BRIEF_ERROR)
                    return []
                }
                resolve(result)
                commit(CONSTANT.BUYER_SHOW_BRIEF_SUCCESS, { id, data: result })
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.BUYER_SHOW_BRIEF_ERROR, e)
            })
        })
    },
    getBuyerInfo({ state, commit }, id) {
        return new Promise((resolve, reject) => {
            const list = state.buyerInfo
            const buyer = _.find(list, (v) => {
                return v.id == id
            })
            if (buyer && (!_.isEmpty(buyer.data))) {
                return resolve(buyer.data)
            }
            return service.getBuyerInfo(id).then(result => {
                if (_.isEmpty(result)) {
                    reject([])
                    commit(CONSTANT.BUYER_INFO_ERROR)
                    return []
                }
                resolve(result)
                commit(CONSTANT.BUYER_INFO_SUCCESS, { id, data: result })
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.BUYER_INFO_ERROR, e)
            })
        })
    },
    getBuyerShowInfo({ state, commit }, id) {
        return new Promise((resolve, reject) => {
            const list = state.buyerShowDetail
            const detail = _.find(list, (v) => {
                return v.id == id
            })
            if (detail && (!_.isEmpty(detail.data))) {
                return resolve(detail.data)
            }
            return service.getBuyerShowInfo(id).then(result => {
                if (_.isEmpty(result)) {
                    reject([])
                    commit(CONSTANT.BUYER_SHOW_DETAIL_ERROR)
                    return []
                }
                resolve(result)
                commit(CONSTANT.BUYER_SHOW_DETAIL_SUCCESS, { id, data: result })
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.BUYER_SHOW_DETAIL_ERROR, e)
            })
        })
    },
    getBuyerShowList({ state, commit }, data) {
        return new Promise((resolve, reject) => {
            const listObj = state.buyerShowList
            if (!_.isEmpty(listObj) && data.pageSize * (data.pageNumber - 1) > listObj.total) {
                return reject()
            }
            return service.getBuyerShowList(data).then(result => {
                if (_.isEmpty(result)) {
                    commit(CONSTANT.BUYER_SHOW_LIST_ERROR)
                    return reject([])
                }
                resolve(result)
                commit(CONSTANT.BUYER_SHOW_LIST_SUCCESS, { id: data.buyerId, list: result.list, total: op(result.page).get('total'), page: data.pageNum })
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.BUYER_SHOW_LIST_ERROR, e)
            })
        })
    },
    /*yeoman-template-point-1*/
}